import { message } from 'antd';
import styled from 'styled-components';
import React from "react";

const MessageContent = styled.p`
  display: inline-block;
  font-size: 13px;
`;

export const messageSuccess = (info) => {
  message.success(<MessageContent>{info}</MessageContent>, 4);
};

export const messageWarning = (info) => {
    message.warning(<MessageContent>{info}</MessageContent>, 5);
};

export const messageError = (info) => {
  message.error(<MessageContent>{info}</MessageContent>, 4);
};
